import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MagentoEcommerceDevelopersInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Magento E-commerce Developers in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Power Your Online Store</Subheading>}
        heading={
          <Heading>
            Magento <span tw="text-primary-500">E-commerce Developers</span> in
            DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our Magento e-commerce developers in **Dubai
            International Financial Centre (DIFC)** craft robust, scalable
            online stores tailored to your business needs. Leverage Magento’s
            power with DIFC’s business expertise to dominate your market.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1577563908411-5077b6dc7624?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build with Magento"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Magento Developers in DIFC"
        description="We deliver Magento stores built for success."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Magento Expertise",
            description: "Certified developers with deep platform knowledge.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Scalable Solutions",
            description: "Stores designed to grow with your business.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Custom Features",
            description: "Tailored functionality for unique needs.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "High Performance",
            description: "Fast, reliable stores for seamless shopping.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Ready",
            description: "Responsive designs for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in DIFC",
            description: "Chosen by DIFC’s leading businesses.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Magento Development Process"
        description={
          <Description>
            We build Magento e-commerce stores with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Align with your business goals.</li>
              <li>Design: Create intuitive, branded layouts.</li>
              <li>Development: Build custom features and integrations.</li>
              <li>Testing: Ensure performance and reliability.</li>
              <li>Launch: Deploy a polished, ready-to-scale store.</li>
              <li>Support: Provide ongoing maintenance and upgrades.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Development workflow
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce analytics
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Discover Our Process"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Impact</Subheading>}
        heading="Magento Success in DIFC"
        description="Our Magento stores deliver real results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Revenue Growth",
            description: "Boosted sales for a DIFC enterprise.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Enhanced Reach",
            description: "Improved visibility for a Magento store.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "High praise from DIFC businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Scale?</Subheading>}
        heading="Magento Developers in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset’s Magento e-commerce developers in DIFC
            to build a powerful, scalable online store. Contact us today to
            transform your e-commerce vision!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1472289065668-ce650ac443d2?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
